import { css, Theme } from "@emotion/react";

export const globalStyles = (theme: Theme) => css`
  html {
    font-size: 100%;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family:
      -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
      sans-serif;
    background-color: ${theme.colors.background};
    color: ${theme.colors.text};
    font-size: ${theme.typography.sizes.md};
    line-height: 1.5;
    color-scheme: ${theme.mode};
    -webkit-font-smoothing: antialiased;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;
  }

  input,
  button,
  textarea,
  select {
    font-family: inherit;
    font-size: inherit;
    color: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    line-height: 1.2;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
